// --- tiny DOM helpers -------------------------------------------------------
function show(el) {
  if (!el) return;
  // remove explicit display:none while leaving stylesheet control intact
  el.style.removeProperty("display");
}

function hide(el) {
  if (!el) return;
  el.style.display = "none";
}

function qSelInParent(el, selector) {
  return el && el.parentElement ? el.parentElement.querySelector(selector) : null;
}

// --- main form validation ---------------------------------------------------
function validateForm() {
  var isValid = Page_ClientValidate(); // built-in ASP.NET validation
  //   if (!isValid) {
  //     if (g_dmDialog_modalDomId.getAttribute("data-content-type") !== "form-not-valid") {
  //       g_dmDialog_modalDomId.setAttribute("data-content-type", "form-not-valid");
  //       g_dmDialog_content.innerHTML = "";

  //       const p1 = document.createElement("p");
  //       p1.classList.add("text--center", "red");
  //       const i = document.createElement("i");
  //       i.classList.add("fa-solid", "fa-triangle-exclamation", "fa-4x");
  //       p1.appendChild(i);

  //       const p2 = document.createElement("p");
  //       p2.textContent =
  //         "Některé povinné položky ve formuláři nejsou vyplněny nebo jsou vyplněny nesprávně. Zkontrolujte je prosím a zkuste odeslat formulář znovu.";

  //       const p3 = document.createElement("p");
  //       p3.classList.add("text--center", "pt--2");
  //       const closeBtnBtn = document.createElement("button");
  //       closeBtnBtn.classList.add("close-modal-btn", "btn-active");
  //       closeBtnBtn.setAttribute("data-bs-dismiss", "modal");

  //       const span1 = document.createElement("span");
  //       span1.textContent = "Zpět na formulář";
  //       closeBtnBtn.appendChild(span1);
  //       p3.appendChild(closeBtnBtn);

  //       appendMultipleChildren(g_dmDialog_content, [p1, p2, p3]);
  //     }

  //     g_dmDialog_modalObj.show();
  //   }
  return isValid;
}

// --- validators -------------------------------------------------------------
function ccvReq(source, args) {
  var obj = document.getElementById(source.controltovalidate);
  var objTitle = obj.getAttribute("title");
  var objVal = (args.Value || "").trim();

  if (objVal === "" || objVal === objTitle) {
    obj.classList.add("is-invalid");
    hideOrShowLabelError(obj, true);
    args.IsValid = false;
  } else {
    obj.classList.remove("is-invalid");
    hideOrShowLabelError(obj, false);
    args.IsValid = true;
  }
}

function ccvDdl(source, args) {
  var obj = document.getElementById(source.controltovalidate);
  var objVal = (args.Value || "").trim();

  if (objVal === "") {
    obj.classList.add("is-invalid");
    hideOrShowLabelError(obj, true);
    args.IsValid = false;
  } else {
    obj.classList.remove("is-invalid");
    hideOrShowLabelError(obj, false);
    args.IsValid = true;
  }
}

function ccvPassword(source, args) {
  var obj = document.getElementById(source.controltovalidate);
  var objTitle = obj.getAttribute("title");
  var objVal = (args.Value || "").trim();

  var re = /^((?=.*[a-zA-Z])[a-zA-Z0-9!@#$%&?*]{6,30})$/;
  var correct = re.test(objVal);

  if (objVal === "" || objVal === objTitle || correct === false) {
    obj.classList.add("is-invalid");
    hideOrShowLabelError(obj, true);
    args.IsValid = false;
  } else {
    obj.classList.remove("is-invalid");
    hideOrShowLabelError(obj, false);
    args.IsValid = true;
  }
}

function ccvName(source, args) {
  var obj = document.getElementById(source.controltovalidate);
  var objTitle = obj.getAttribute("title");
  var objVal = (args.Value || "").trim();

  if (objVal === "" || objVal === objTitle || objVal.length < 2) {
    obj.classList.remove("is-valid");
    obj.classList.add("is-invalid");
    hideOrShowLabelError(obj, true);
    args.IsValid = false;
  } else {
    obj.classList.add("is-valid");
    obj.classList.remove("is-invalid");
    hideOrShowLabelError(obj, false);
    args.IsValid = true;
  }
}

function ccvEmail(source, args) {
  var obj = document.getElementById(source.controltovalidate);
  var objTitle = obj.getAttribute("title");
  var objVal = (args.Value || "").trim();

  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  var correct = re.test(objVal);

  if (objVal === "" || objVal === objTitle || correct === false) {
    obj.classList.remove("is-valid");
    obj.classList.add("is-invalid");
    hideOrShowLabelError(obj, true);
    args.IsValid = false;
  } else {
    obj.classList.add("is-valid");
    obj.classList.remove("is-invalid");
    hideOrShowLabelError(obj, false);
    args.IsValid = true;
  }
}

function ccvTel(source, args) {
  var obj = document.getElementById(source.controltovalidate);
  var objTitle = obj.getAttribute("title");
  var objVal = (args.Value || "").trim();

  var re = /^(?=(?:\D*\d){9,})[0-9()+\s-]{9,35}$/;
  var correct = re.test(objVal);

  var container = obj.closest(".form-floating");
  var labelErr = container ? container.querySelector(".input-label-error") : null;

  if (objVal === "" || objVal === objTitle || correct === false) {
    obj.classList.remove("is-valid");
    obj.classList.add("is-invalid");
    show(labelErr);
    args.IsValid = false;
  } else {
    obj.classList.add("is-valid");
    obj.classList.remove("is-invalid");
    hide(labelErr);
    args.IsValid = true;
  }
}

function ccvAsCode(source, args) {
  var obj = document.getElementById(source.controltovalidate);
  var objTitle = obj.getAttribute("title");
  var objVal = (args.Value || "").trim();

  if (objVal === "" || objVal === objTitle) {
    obj.classList.add("is-invalid");
    hideOrShowLabelError(obj, true);
    args.IsValid = false;
  } else {
    obj.classList.remove("is-invalid");
    hideOrShowLabelError(obj, false);
    args.IsValid = true;
  }
}

function ccvSingleNumber(source, args) {
  var obj = document.getElementById(source.controltovalidate);
  var objTitle = obj.getAttribute("title");
  var objVal = (args.Value || "").trim();

  var re = /^\d{1,2}$/;
  var correct = re.test(objVal);

  if (objVal === "" || objVal === objTitle || correct === false) {
    obj.classList.add("is-invalid");
    hideOrShowLabelError(obj, true);
    args.IsValid = false;
  } else {
    obj.classList.remove("is-invalid");
    hideOrShowLabelError(obj, false);
    args.IsValid = true;
  }
}

function ccvText(source, args) {
  var obj = document.getElementById(source.controltovalidate);
  var objTitle = obj.getAttribute("title");
  var objVal = (args.Value || "").trim();

  if (objVal === "" || objVal === objTitle) {
    obj.classList.add("is-invalid");
    hideOrShowLabelError(obj, true);
    args.IsValid = false;
  } else {
    obj.classList.remove("is-invalid");
    hideOrShowLabelError(obj, false);
    args.IsValid = true;
  }
}

function ccvIco(source, args) {
  var obj = document.getElementById(source.controltovalidate);
  var objTitle = obj.getAttribute("title");
  var objVal = (args.Value || "").trim();

  var correct = /^\d{8}$/.test(objVal);

  if (objVal === "" || objVal === objTitle || correct === false) {
    obj.classList.add("is-invalid");
    hideOrShowLabelError(obj, true);
    args.IsValid = false;
  } else {
    obj.classList.remove("is-invalid");
    hideOrShowLabelError(obj, false);
    args.IsValid = true;
  }
}

function ccvText_nr(source, args) {
  var obj = document.getElementById(source.controltovalidate);
  var objTitle = obj.getAttribute("title");
  var objVal = (args.Value || "").trim();

  if (objVal === "" || objVal === objTitle) {
    // nothing to do for non-required field
    return;
  } else {
    obj.classList.add("is-valid");
    args.IsValid = true;
  }
}

function ccvText_nr_min5(source, args) {
  var obj = document.getElementById(source.controltovalidate);
  var objTitle = obj.getAttribute("title");
  var objVal = (args.Value || "").trim();

  if (objVal === "" || objVal === objTitle) {
    obj.classList.remove("is-invalid");
    obj.classList.remove("is-valid");
    hideOrShowLabelError(obj, false);
    args.IsValid = true;
  } else if (objVal.length < 5) {
    obj.classList.add("is-invalid");
    obj.classList.remove("is-valid");
    hideOrShowLabelError(obj, true);
    args.IsValid = false;
  } else {
    obj.classList.add("is-valid");
    obj.classList.remove("is-invalid");
    hideOrShowLabelError(obj, false);
    args.IsValid = true;
  }
}

// Required checkbox (called directly on the checkbox element)
function xccvCheckbox(obj) {
  if (obj.checked === true) {
    var evalObj = obj.parentElement ? obj.parentElement.querySelector(".evalFailed") : null;
    // hide if present (regardless of current visibility)
    hide(evalObj);
  }
}

// --- shared label error toggling -------------------------------------------
function hideOrShowLabelError(inputEl, showError) {
  var labelErr = qSelInParent(inputEl, ".input-label-error");
  if (showError) show(labelErr);
  else hide(labelErr);
}

// ---------------------------------------------------------------------------
// intl-tel-input (international phone prefix selector)
// ---------------------------------------------------------------------------
// Auto-applied to every <input class="form-type-tel"> on the page. The library
// (intlTelBundle.min.js) + CSS are loaded globally by the master page; the
// libphonenumber utils are bundled, so validation/formatting need no extra
// script. Each control wires its phone CustomValidator to ccvTelIntl and calls
// syncTelForSubmit() from the submit button just before postback.

// Locate the .input-label-error <p> for a field (top-label or floating layout).
function telLabelError(input) {
  var container = input
    ? input.closest(".form-item") || input.closest(".form-floating")
    : null;
  return container ? container.querySelector(".input-label-error") : null;
}

// Client-side validator referenced by cvTel (ASP.NET CustomValidator).
// Prefers intl-tel-input's libphonenumber-backed validity; falls back to the
// legacy "9+ digits" regex if the plugin failed to load.
function ccvTelIntl(source, args) {
  var input = document.getElementById(source.controltovalidate);
  var val = (args.Value || "").trim();
  var iti = input && input._iti;
  var labelErr = telLabelError(input);

  var ok;
  if (!val) {
    ok = false; // required field
  } else if (iti && typeof iti.isValidNumber === "function") {
    ok = iti.isValidNumber();
  } else {
    ok = /^(?=(?:\D*\d){9,})[0-9()+\s-]{9,35}$/.test(val);
  }

  if (input) {
    input.classList.toggle("is-valid", ok);
    input.classList.toggle("is-invalid", !ok);
  }
  if (labelErr) labelErr.style.display = ok ? "none" : "";
  args.IsValid = ok;
}

// Build a display-formatted international number: "(+420) 603 506 712".
function formatItiNumber(iti) {
  if (!iti || typeof iti.getNumber !== "function") return "";
  // INTERNATIONAL format groups the national part correctly per country and
  // separates the dial code with a space, e.g. "+420 603 506 712".
  var nf =
    window.intlTelInput &&
    window.intlTelInput.utils &&
    window.intlTelInput.utils.numberFormat;
  var intl = iti.getNumber(nf ? nf.INTERNATIONAL : 1) || iti.getNumber();
  if (!intl) return "";
  var sp = intl.indexOf(" ");
  return intl.charAt(0) === "+" && sp > 0
    ? "(" + intl.slice(0, sp) + ") " + intl.slice(sp + 1)
    : intl;
}

// Called from each form's send button right before postback: rewrite every
// intl-tel field with the formatted international number so the server and the
// notification email receive "(+420) 603 506 712" instead of national digits.
function syncTelForSubmit() {
  var inputs = document.querySelectorAll("input.form-type-tel");
  Array.prototype.forEach.call(inputs, function (input) {
    var iti = input._iti;
    if (!iti) return;
    var formatted = formatItiNumber(iti);
    if (formatted) input.value = formatted;
  });
}

// Initialise intl-tel-input on every phone field not yet wired.
function initIntlTelInputs() {
  if (!window.intlTelInput) return;
  var inputs = document.querySelectorAll("input.form-type-tel");
  Array.prototype.forEach.call(inputs, function (input) {
    if (input._iti) return; // already initialised
    input._iti = window.intlTelInput(input, {
      initialCountry: "cz",
      separateDialCode: true, // show the +420 prefix next to the flag
      nationalMode: true, // user types the national number
      autoPlaceholder: "off",
      countrySearch: true, // searchable country dropdown
      dropdownContainer: document.body, // avoid clipping inside the form
      countryOrder: ["cz", "sk", "de", "pl", "at", "us", "gb"],
      // To preselect by geolocation instead of CZ, set initialCountry:'auto'
      // and add a geoIpLookup callback hitting an IP service — note the
      // GDPR/consent + latency trade-off of that third-party request.
    });
  });
}

// ---------------------------------------------------------------------------
// ASP.NET checkbox -> Bootstrap .form-check-input
// ---------------------------------------------------------------------------
// ASP.NET CheckBox controls with CssClass="convert-to-form-check" render as
// <span class="convert-to-form-check"><input type="checkbox"></span>. Add the
// Bootstrap class so they pick up the nicer styling. Previously this was an
// inline <script> duplicated on every form page; centralised here instead.
function convertFormCheckboxes() {
  var inputs = document.querySelectorAll("span.convert-to-form-check input");
  Array.prototype.forEach.call(inputs, function (el) {
    el.classList.add("form-check-input");
  });
}

// --- shared init -----------------------------------------------------------
function initAspxForms() {
  initIntlTelInputs();
  convertFormCheckboxes();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initAspxForms);
} else {
  initAspxForms();
}
